export const smaartCardUrl = "https://smaartcard.com:8443";

// export const smaartCardUrl = "https://smartcard.vasyerp.in";
// export const smaartCardUrl = "http://localhost:8444";

// export const smaartCardUrl = "http://192.168.149.28:8443";
